import { IErsHttpParams }        from '@core/interfaces/api.interface';
import { AllowedDetailsTabEnum } from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                from '@core/interfaces/route.interface';


export enum ErsRoutesEnum {
	ListPage = '',
	DetailPage = ':ersId',
	DetailPageTab = ':ersId/:tab',
	FormPageCreate = 'create',
	FormPageUpdate = ':ersId/update',
	// External
	ExternalListPage = 'external',
	ExternalDetailPage = 'external/:ersId',
	ExternalDetailPageTab = 'external/:ersId/:tab',
	ExternalFormPageCreate = 'external/create',
	ExternalFormPageUpdate = 'external/:ersId/update',
}

// Base
export interface ErsListPageBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Ers;
	queryParams?: IErsHttpParams;
}

export interface ErsDetailPageBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Ers;
	params: { ersId: string };
}

export interface ErsDetailPageTabBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Ers;
	params: {
		ersId: string,
		tab: AllowedDetailsTabEnum
	};
	replaceLastStoredRouteWithNew: boolean;
}

export interface ErsFormPageCreateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Ers;
	params: { businessPremisesId: string };
}

export interface ErsFormPageUpdateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Ers;
	params: { ersId: string };
}


// ERS
export interface ErsListPageRoute extends ErsListPageBaseRoute {
	path: ErsRoutesEnum.ListPage;
}

export interface ErsDetailPageRoute extends ErsDetailPageBaseRoute {
	path: ErsRoutesEnum.DetailPage;
}

export interface ErsDetailPageTabRoute extends ErsDetailPageTabBaseRoute {
	path: ErsRoutesEnum.DetailPageTab;
}

export interface ErsFormPageCreateRoute extends ErsFormPageCreateBaseRoute {
	path: ErsRoutesEnum.FormPageCreate;
}

export interface ErsFormPageUpdateRoute extends ErsFormPageUpdateBaseRoute {
	path: ErsRoutesEnum.FormPageUpdate;
}


// External
export interface ErsExternalListPageRoute extends ErsListPageBaseRoute {
	path: ErsRoutesEnum.ExternalListPage;
}

export interface ErsExternalDetailPageRoute extends ErsDetailPageBaseRoute {
	path: ErsRoutesEnum.ExternalDetailPage;
}

export interface ErsExternalDetailPageTabRoute extends ErsDetailPageTabBaseRoute {
	path: ErsRoutesEnum.ExternalDetailPageTab;
}

export interface ErsExternalFormPageCreateRoute extends ErsFormPageCreateBaseRoute {
	path: ErsRoutesEnum.ExternalFormPageCreate;
}

export interface ErsExternalFormPageUpdateRoute extends ErsFormPageUpdateBaseRoute {
	path: ErsRoutesEnum.ExternalFormPageUpdate;
}
